import { render, staticRenderFns } from "./FacialBiometryModal.vue?vue&type=template&id=02ccacc4&scoped=true"
import script from "./FacialBiometryModal.vue?vue&type=script&lang=js"
export * from "./FacialBiometryModal.vue?vue&type=script&lang=js"
import style0 from "./FacialBiometryModal.vue?vue&type=style&index=0&id=02ccacc4&prod&lang=scss"
import style1 from "./FacialBiometryModal.vue?vue&type=style&index=1&id=02ccacc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ccacc4",
  null
  
)

export default component.exports